import { HTMLAttributes } from "react";

import { icons } from "./icons";

export type IconName = keyof typeof icons;

interface Props extends HTMLAttributes<HTMLDivElement> {
  icon: IconName;
  className?: string;
}

const Icon = ({ icon, className, ...props }: Props) => {
  return (
    <div className={className} aria-description={icon} {...props}>
      {icons[icon]}
    </div>
  );
};

export default Icon;
